import { css } from '@emotion/react'
import common from 'shared/styles/common.styles'

const styles = () => {
    return {
        container: css`
            ${common.fullContainer};
            display: flex;
            flex-direction: column;
        `,
        content: css`
            ${common.flexJustityAlignCenter};
            flex-direction: column;
        `,
    }
}

export default styles
